
import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import ErrorBoundary from './components/ErrorBoundary';
import App from './App.tsx';
import './index.css';

// Global error fallback component
const ErrorFallback = () => (
  <div style={{
    padding: '20px',
    textAlign: 'center',
    color: '#f97316',
    background: '#121212',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  }}>
    <div style={{ fontSize: '48px', marginBottom: '20px' }}>⚠️</div>
    <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>Something went wrong</h1>
    <p style={{ marginBottom: '20px', color: '#999' }}>The application encountered an error.</p>
    <button 
      onClick={() => window.location.reload()}
      style={{
        background: '#f97316',
        color: 'white',
        border: 'none',
        padding: '8px 16px',
        borderRadius: '4px',
        cursor: 'pointer'
      }}
    >
      Refresh Page
    </button>
  </div>
);

// Error boundary wrapper component
const ErrorBoundaryWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <ErrorBoundary fallback={<ErrorFallback />}>
      {children}
    </ErrorBoundary>
  );
};

// Create root element with error handling
const rootElement = document.getElementById("root");

if (!rootElement) {
  console.error("Failed to find the root element");
  document.body.innerHTML = '<div style="color: #f97316; text-align: center; padding: 20px;">Failed to initialize application. Please refresh the page or contact support.</div>';
} else {
  // Initialize the app with error boundary at the root
  createRoot(rootElement).render(
    <StrictMode>
      <ErrorBoundaryWrapper>
        <App />
      </ErrorBoundaryWrapper>
    </StrictMode>
  );
}

// Set browser title dynamically if needed
document.title = document.title || "CIPP Resources by CyberDrain";
